// Browsers (including installed PWAs) start manually. A native host must
// explicitly advertise that its playback policy permits startup audio.
export function supportsStartupPlayback(runtime=globalThis){
  return runtime.window?.tuneMondoNative?.capabilities?.resumePlaybackOnStartup===true;
}
